import AboutContent from '../components/About/AboutContent';

const About = () => {
  const leadershipTeam = [
    {
      id: 1,
      name: "Abasi Ekpenyon",
      role: "Chief Executive Officer",
      bio: "Over 10 years of experience in technology leadership and business transformation. Visionary leader driving innovation.",
      initials: "AE"
    },
    {
      id: 2,
      name: "Onochie Okeke Onyekachi",
      role: "Chief Technical Officer",
      bio: "Former senior developer at Google with 8+ years experience in scalable architecture and cloud solutions.",
      initials: "OO"
    },
    {
      id: 3,
      name: "Franklin Inyang",
      role: "Head of Product",
      bio: "Product strategist with expertise in UX/UI design and market analysis across multiple industries.",
      initials: "FI"
    },
    {
      id: 4,
      name: "Mark Edoho",
      role: "Head of Operations",
      bio: "Operations expert with background in project management and process optimization for tech companies.",
      initials: "ME"
    },
    {
      id: 5,
      name: "Stephen David",
      role: "Head of Marketing",
      bio: "Digital marketing specialist with proven track record in brand development and growth strategies.",
      initials: "SD"
    },
    {
      id: 6,
      name: "Charles Umoren",
      role: "Lead Developer",
      bio: "Full-stack developer with expertise in React, Node.js, and cloud-native applications.",
      initials: "CU"
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding bg-gradient-to-r from-primary-50 to-gray-50">
        <div className="container-custom text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            About <span className="text-primary-600">Tally Technologies</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Leading the digital transformation revolution since 2024. 
            We're committed to delivering innovative technology solutions that drive business growth.
          </p>
        </div>
      </section>

      <AboutContent />

      {/* Team Section */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <h2 className="text-4xl font-bold text-center mb-4">Our Leadership</h2>
          <p className="text-gray-600 text-center mb-12 max-w-2xl mx-auto">
            Meet the dedicated team driving innovation and excellence at Tally Technologies
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {leadershipTeam.map((member) => (
              <div key={member.id} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="w-24 h-24 bg-gradient-to-br from-primary-100 to-primary-200 rounded-full mx-auto mb-6 flex items-center justify-center">
                  <span className="text-3xl font-bold text-primary-700">{member.initials}</span>
                </div>
                <h3 className="text-xl font-bold text-center mb-2">{member.name}</h3>
                <p className="text-primary-600 text-center font-medium mb-4">{member.role}</p>
                <p className="text-gray-600 text-center text-sm leading-relaxed">
                  {member.bio}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;